import {
  API_BASE_URL,
  AUTH_TOKEN_KEY,
} from 'lib/constants';
import {
  AuthenticationError,
} from 'lib/errors';

export const setAuthToken = (token) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export const getAuthToken = () => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

export const authenticate = (verification_token) => {
  if (!verification_token) {
    throw new AuthenticationError('Verification token not provided');
  }

  return fetch(`${API_BASE_URL}/start/applications/authenticate`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }),
    body: JSON.stringify({token: verification_token}),
  })
  .then(response => {
    return response.json().then(data => {
      if (data && data.application_token) {
        setAuthToken(data.application_token);
      }
      else if (data && data.error) {
        // if there is an authentication error, clear cache and redirect to main screen
        localStorage.clear();
        window.location.replace("/");
      }
      return data;
    })
  })
  .catch((error) => {
    throw new Error(error);
  })
}
